export default "__VITE_ASSET__BM54s_D6__"